import { render, staticRenderFns } from "./lettering.vue?vue&type=template&id=0ab4982e&"
import script from "./lettering.vue?vue&type=script&lang=js&"
export * from "./lettering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuSpacer: require('/codebuild/output/src1887633789/src/kokalanov/components/global/MenuSpacer.vue').default,PageContentSections: require('/codebuild/output/src1887633789/src/kokalanov/components/PageContentSections.vue').default,Footer: require('/codebuild/output/src1887633789/src/kokalanov/components/global/Footer.vue').default,SEO: require('/codebuild/output/src1887633789/src/kokalanov/components/global/SEO.vue').default,PreviewModeWrapper: require('/codebuild/output/src1887633789/src/kokalanov/components/global/PreviewModeWrapper.vue').default})
